import React from 'react';
import classes from './LinkList.module.css';
import Button from '../../../UI/Button';
import LabeledText from '../../LabeledText';
import { formatPhoneNumber } from '../../../../Helpers';
import clsx from 'clsx';
import { getRelevantMrValue } from '../../../../Helpers';
const LinkList = ({ data, setSelectedItem, onClick, setShow, className, onCreateAppointment }) => {

  return (
    <div className={clsx(classes.wrapper, className)}>
      <header className={classes.header}>
        <p className={classes.label}>{data?.name}</p>

        <p className={classes.number}>MR No. {getRelevantMrValue(data?.emrNo)}</p>
      </header>
      <div className={classes.actionAndInfo}>
        <LabeledText
          label={'Phone Number:'}
          value={formatPhoneNumber(data?.cellNumber)}
        />
        <menu className={classes.actionMenu}>
          {onCreateAppointment && (
            <Button
              className={classes.selectBtn}
              label={'Select'}
              variants={'secondary'}
              onClick={() => {
                if (typeof onCreateAppointment === 'function') {
                  if (typeof setSelectedItem === 'function') setSelectedItem(data);
                  onCreateAppointment();
                }
              }}
            />
          )}
          {onClick && (
            <Button
              className={classes.selectBtn}
              label={'Select'}
              variants={'secondary'}
              onClick={() => {
                if (typeof onClick === 'function') {
                  if (typeof setSelectedItem === 'function') setSelectedItem(data);
                  onClick();
                }
              }}
            />
          )}
        </menu>
      </div>
    </div>
  );
};

export default LinkList;
